
const commitVersion = "GreenMag Beta 0.49";

const match = commitVersion.match(/\.([0-9]+)$/);

if (match) {
  window.vv = parseInt(match[1], 10); 
} else {
  window.vv = null;
  console.warn('Не удалось получить номер версии');
}
